export type ToastType = "error" | "success";

export type ToastLink = {
  text: string;
  url: string;
};

export type ToastMessage = {
  id: string;
  link?: ToastLink;
  message: string;
  type: ToastType;
};

type ToastListener = (toast: ToastMessage) => void;
const listeners = new Set<ToastListener>();

let toastIdCounter = 0;

export const onToast = (listener: ToastListener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const notify = (type: ToastType, message: string, link?: ToastLink) => {
  const toast: ToastMessage = {
    id: `toast-${++toastIdCounter}`,
    link,
    message,
    type,
  };
  listeners.forEach(listener => listener(toast));
};

export const notifySuccess = (message: string, link?: ToastLink) => {
  notify("success", message, link);
};

export const notifyError = (message: string) => {
  notify("error", message);
};
